module.exports = __webpack_public_path__ + "static/sky-cfe74176008ef9680ce6ebc713f025d5.jpg";